<!-- <p>events works!</p> -->
@let noResultMessage = "No Results Matching the Filter";

@if (!dataSourceRule && !dataSourceOffline && !dataSourceDeviation && !dataSourceWebhook) {
<app-loading-template DisplayText="Please wait while we load Event information" />
} @else {
<div class="main-events-div ">
	<div class="alignRow">
		<span>
			<h1>Events</h1>
		</span>
		<span class="toolbar-spacer"></span>
		<div style="display: flex; flex-direction: row; gap: 0.5em;" class="alignRow">

			@if (filterDescription) {
			<span>{{filterDescription}}</span>
			}

			@if (formattedStartDate && formattedEndDate) {
			<mat-icon style="cursor: pointer;" (click)="resetQueryDates()">close</mat-icon>
			}

			<div class="date-picker-div">
				<button mat-raised-button [matMenuTriggerFor]="timeMenu" #timeTrigger="matMenuTrigger">
					<span>Date Range</span>
					<mat-icon>access_time</mat-icon>
				</button>
				@if (selectedTabIndex != 3) {
				<button mat-raised-button class="filter-button" [matMenuTriggerFor]="filterMenu">
					<span>Filters</span>
					<mat-icon>tune</mat-icon>
				</button>
				}
			</div>
		</div>
	</div>
	<mat-menu #timeMenu="matMenu">
		<div style="margin: 1em;">
			<app-date-range-picker (datePickerChange)="DatePickerChange($event)"
				[matMenuTrigger]="timeTrigger"></app-date-range-picker>
		</div>
	</mat-menu>

	<mat-menu #filterMenu>
		<div class="filter-switch-div">

			@if (selectedTabIndex === 0 || selectedTabIndex === 1 || selectedTabIndex === 2) {
			<div class="enabled-switch-div"><span style="margin-right: 0.2em;">Acknowledged</span></div>
			<mat-checkbox color="primary" (click)="$event.stopPropagation()"
				[(ngModel)]="filterQueryParams.Acknowledged" (change)="onFilterChange('Acknowledged')" />

			<div class="enabled-switch-div"> <span style="margin-right: 0.2em;">Not Acknowledged</span> </div>
			<mat-checkbox color="primary" (click)="$event.stopPropagation()"
				[(ngModel)]="filterQueryParams.Unacknowledged" (change)="onFilterChange('Unacknowledged')" />
			}

			@if (selectedTabIndex === 0) {

			<div class="enabled-switch-div"> <span style="margin-right: 0.2em;">SAP Case</span> </div>
			<mat-checkbox color="primary" (click)="$event.stopPropagation()" [(ngModel)]="filterQueryParams.CMMS"
				(change)="onFilterChange('CMMS')" />

			<div class="enabled-switch-div"> <span style="margin-right: 0.2em;">Not SAP Case</span> </div>
			<mat-checkbox color="primary" (click)="$event.stopPropagation()" [(ngModel)]="filterQueryParams.notCMMS"
				(change)="onFilterChange('notCMMS')" />

			<div class="enabled-switch-div"> <span style="margin-right: 0.2em;">Archived</span> </div>
			<mat-checkbox color="primary" (click)="$event.stopPropagation()" [(ngModel)]="filterQueryParams.Archived"
				(change)="onFilterChange('Archived')" />

			<div class="enabled-switch-div"> <span style="margin-right: 0.2em;">Not Archived</span> </div>
			<mat-checkbox color="primary" (click)="$event.stopPropagation()" [(ngModel)]="filterQueryParams.Unarchived"
				(change)="onFilterChange('Unarchived')" />
			}

		</div>
	</mat-menu>

	<div class="middle-div alignRow">
		<span class="toolbar-spacer"></span>
		<div class="location-dropdown">
			<ejs-dropdownlist id="locationDropdown" #locationDropdown [dataSource]='MainLocations'
				placeholder="Select Location" [fields]="locationFields" (change)="filterByLocation($event)"
				[allowFiltering]="true" [(ngModel)]="this.filterQueryParams.Location" filterType="contains"
				[showClearButton]="true">
				<ng-template #itemTemplate let-data>
					<div>
						<span>{{data.Name}}</span>
					</div>
				</ng-template>
			</ejs-dropdownlist>
		</div>
	</div>
	<ejs-tab id="element" [selectedItem]="selectedTabIndex" (selected)="tabChange($event)">
		<e-tabitems>
			<e-tabitem #rulesTab>
				<ng-template #headerText>
					<span class="alignRow">
						<mat-icon>rule</mat-icon>
						<span>&nbsp;Rule Events&nbsp;</span>
						<mat-spinner *ngIf="isRulesLoading" diameter="20" />
					</span>
				</ng-template>
				<ng-template #content>
					<div>
						<ng-container *ngTemplateOutlet="RuleEventsTab"></ng-container>
					</div>
				</ng-template>
			</e-tabitem>
			<e-tabitem>
				<ng-template #headerText>
					<span class="alignRow">
						<mat-icon>sensors_off</mat-icon>
						<span>&nbsp;Sensor Offline Events&nbsp;</span>
						<mat-spinner *ngIf="isOfflineLoading" diameter="20" />
					</span>
				</ng-template>
				<ng-template #content>
					<div>
						<ng-container *ngTemplateOutlet="OfflineEventsTab"></ng-container>
					</div>
				</ng-template>
			</e-tabitem>
			<e-tabitem>
				<ng-template #headerText>
					<span class="alignRow">
						<mat-icon>insights</mat-icon>
						<span>&nbsp;Deviation Events&nbsp;</span>
						<mat-spinner *ngIf="isDeviationsLoading" diameter="20" />
					</span>
				</ng-template>
				<ng-template #content>
					<div>
						<ng-container *ngTemplateOutlet="DeviationEventsTab"></ng-container>
					</div>
				</ng-template>
			</e-tabitem>
			<e-tabitem>
				<ng-template #headerText>
					<span class="alignRow">
						<mat-icon>webhook</mat-icon>
						<span>&nbsp;Webhook Events&nbsp;</span>
						<mat-spinner *ngIf="isWebhooksLoading" diameter="20" />
					</span>
				</ng-template>
				<ng-template #content>
					<div>
						<ng-container *ngTemplateOutlet="WebhookEventsTab"></ng-container>
					</div>
				</ng-template>
			</e-tabitem>
		</e-tabitems>
	</ejs-tab>
</div>
}

<ng-template #RuleEventsTab>
	<div class="events-list-div">
		<div class="filter-table-div">
			<mat-form-field>
				<mat-label>Search for an Event, Asset, Rule, or Comment</mat-label>
				<input matInput (keyup)="onFilteringRuleEvents($event)" placeholder="" #inputRuleFilter
					[(ngModel)]="filterQueryParams.eventsFilter">
			</mat-form-field>
			@if (dataSourceRule && dataSourceRule.filteredData.length > 0) {
			<div class="table-container">
				<table mat-table matSort #tableRules #sortRule="matSort" [dataSource]="dataSourceRule"
					[matSortActive]="filterQueryParams.eventsSortColumn || ''"
					[matSortDirection]="filterQueryParams.eventsSortDirection || ''"
					(matSortChange)="onEventSortChange($event)">
					<ng-container matColumnDef="timestamp">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Timestamp</th>
						<td mat-cell *matCellDef="let row">
							<span class="alignRow">
								{{row.TimeStamp | date:'dd MMMM yyyy HH:mm'}}
							</span>
						</td>
					</ng-container>
					<ng-container matColumnDef="rule">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Triggered by Rule</th>
						<td mat-cell *matCellDef="let row">
							<span class="alignRow">{{row.RuleName}}</span>
						</td>
					</ng-container>
					<ng-container matColumnDef="comments">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Comments</th>
						<td class="comments-no-overflow" mat-cell *matCellDef="let row">
							@if (row.Comments.length <= 41) { <span>{{row.Comments}}</span>
								} @else {
								<span title="{{row.Comments}}">{{row.Comments}}</span>
								}
						</td>
					</ng-container>
					<ng-container matColumnDef="acknowledged">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Acknowledged</th>
						<td [ngStyle]="{'color': !row.Acknowledged ? 'Salmon' : ''}" mat-cell *matCellDef="let row">
							@if (row.Acknowledged && row.AcknowledgedUser != '') {
							<span class="alignRow" matTooltip="By {{row.AcknowledgedUser}}" matTooltipPosition="right">
								{{row.AcknowledgedTimestamp | date:'dd MMMM yyyy'}}
							</span>
							}
							@if (row.Acknowledged && row.AcknowledgedUser == ''){
							<span class="alignRow">Yes</span>
							}
							@if (!row.Acknowledged) {
							<span class="alignRow" style="color: var(--color-red);">No</span>
							}
						</td>
					</ng-container>
					<ng-container matColumnDef="archiveButton">
						<th mat-header-cell *matHeaderCellDef>Archive</th>
						<td style="justify-content: center;" mat-cell *matCellDef="let row">
							@if (!row.Acknowledged) {
							<span class="app-icon">
								<mat-icon style="color: lightgray !important;"
									matTooltip="Event Not Acknowledged">delete</mat-icon>
							</span>
							}
							@if (row.Acknowledged) {
							@if (!row.Archived) {
							<span class="app-icon app-icon--delete">
								<mat-icon matTooltip="Event Not Archived" />
							</span>
							}@else {
							<span class="app-icon">
								<mat-icon style="color: lightgray;"
									matTooltip="Event Archived">restore_from_trash</mat-icon>
							</span>
							}
							}
						</td>
					</ng-container>
					<ng-container matColumnDef="CaseID">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>SAP Case</th>
						<td style="justify-content: left;" mat-cell *matCellDef="let row">
							<span class="app-icon">
								<mat-icon [ngStyle]="{'color': row.CaseID ? 'lightgreen':'salmon'}">{{row.CaseID ?
									'check' :
									'close'}}</mat-icon>
							</span>
						</td>
					</ng-container>

					<ng-container matColumnDef="Action">
						<th mat-header-cell *matHeaderCellDef></th>
						<td style="justify-content: left;" mat-cell *matCellDef="let row">
							<span class="app-icon" [matMenuTriggerFor]="RuleActionMenu">
								<mat-icon>more_horiz</mat-icon>
							</span>

							<mat-menu #RuleActionMenu>

								<button mat-menu-item (click)="goToRule(row)" class="app-icon app-icon--rules">
									<mat-icon /><span>Rule Info</span>
								</button>

								<button mat-menu-item (click)="goToAsset(row)" class="app-icon app-icon--goto">
									<mat-icon /><span>View Asset</span>
								</button>

								<button mat-menu-item (click)="selectCase(row)" class="app-icon app-icon--sapCases"
									[disabled]="!row.CaseID">
									<mat-icon /><span>View SAP Case</span>
								</button>

								@if (!row.Archived) {
								<button mat-menu-item (click)="archiveRuleEvent(row)" class="app-icon app-icon--delete"
									[disabled]="!row.Acknowledged">
									<mat-icon /><span>Archive</span>
								</button>
								}
								@if (row.Archived) {
								<button mat-menu-item (click)="archiveRuleEvent(row,false)">
									<mat-icon>restore_from_trash</mat-icon><span>Restore</span>
								</button>
								}
							</mat-menu>
						</td>
					</ng-container>

					<ng-container matColumnDef="GoToEvent">
						<th mat-header-cell *matHeaderCellDef></th>
						<td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row">
							<span class="app-icon" (click)="selectEvent(row)" matTooltip="Go To Event">
								<mat-icon>rule</mat-icon>
							</span>
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumnsRule"></tr>
					<tr mat-row class="table-row" *matRowDef="let row; columns: displayedColumnsRule;"></tr>
					<tr class="mat-row" *matNoDataRow>
						<td class="mat-cell" colspan="4">
							@if (inputRuleFilter.value != '') {
							<span>{{noResultMessage}}:"{{inputRuleFilter.value}}"</span>
							} @else {
							<span>{{noResultMessage}}</span>
							}
						</td>
					</tr>
				</table>
				<mat-paginator #paginatorRule [pageSizeOptions]="[5, 10, 25, 100]"
					[pageSize]="filterQueryParams.eventspageSize ?? 10" [pageIndex]="filterQueryParams.eventspageIndex"
					(page)="onPageChange(paginatorRule, $event)" aria-label="Select page of rules"></mat-paginator>
			</div>
			}
			@if (RuleEvents && RuleEvents.length == 0) {<div>{{noResultMessage}}</div>}
		</div>
	</div>
</ng-template>

<ng-template #OfflineEventsTab>
	<div class="events-list-div">
		<div class="filter-table-div">
			<mat-form-field>
				<mat-label>Search for an Event</mat-label>
				<input matInput (keyup)="onFilteringOfflineEvents($event)" placeholder="" #inputOfflineFilter
					[(ngModel)]="filterQueryParams.offlineFilter">
			</mat-form-field>
			@if (dataSourceOffline && dataSourceOffline.filteredData.length > 0) {
			<div class="table-container">
				<table mat-table matSort #tableOffline #sortOffline="matSort" [dataSource]="dataSourceOffline"
					[matSortActive]="filterQueryParams.offlineSortColumn || ''"
					[matSortDirection]="filterQueryParams.offlineSortDirection || ''"
					(matSortChange)="onOfflineSortChange($event)">
					<ng-container matColumnDef="timestamp">
						<th mat-header-cell *matHeaderCellDef>Timestamp</th>
						<td mat-cell *matCellDef="let row">
							<span class="alignRow">{{row.TimeStamp | date:'dd MMMM yyyy HH:mm'}}</span>
						</td>
					</ng-container>
					<ng-container matColumnDef="sensor">
						<th mat-header-cell *matHeaderCellDef>Triggered by Sensor</th>
						<td mat-cell *matCellDef="let row">
							<span>{{row.SensorName}}</span>
						</td>
					</ng-container>
					<ng-container matColumnDef="acknowledged">
						<th mat-header-cell *matHeaderCellDef>Acknowledged</th>
						<td [ngStyle]="{'color': !row.Acknowledged ? 'Salmon' : ''}" mat-cell *matCellDef="let row">
							@if (row.Acknowledged && row.AcknowledgedUser != '') {
							<span class="alignRow" matTooltip="By {{row.AcknowledgedUser}}" matTooltipPosition="right">
								{{row.AcknowledgedTimestamp | date:'dd MMMM yyyy'}}
							</span>
							}
							@if (row.Acknowledged && row.AcknowledgedUser == ''){
							<span class="alignRow">Yes</span>
							}
							@if (!row.Acknowledged) {
							<span class="alignRow" style="color: var(--color-red);">No</span>
							}
						</td>
					</ng-container>

					<!-- <ng-container matColumnDef="Action">
						<th mat-header-cell *matHeaderCellDef></th>
						<td style="justify-content: left;" mat-cell *matCellDef="let row">
							<button mat-icon-button [matMenuTriggerFor]="RuleActionMenu">
								<mat-icon>more_horiz</mat-icon>
							</button>

							<mat-menu #RuleActionMenu>

								<button mat-menu-item (click)="selectOfflineEvent(row)" class="app-icon">
									<mat-icon>sensors_off</mat-icon><span>View Event</span>
								</button>

							</mat-menu>
						</td>
					</ng-container> -->

					<ng-container matColumnDef="GoToEvent">
						<th mat-header-cell *matHeaderCellDef></th>
						<td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row">
							<span class="app-icon" (click)="selectOfflineEvent(row)" matTooltip="Go To Event">
								<mat-icon>sensors_off</mat-icon>
							</span>
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumnsOffline"></tr>
					<tr mat-row class="table-row" *matRowDef="let row; columns: displayedColumnsOffline;"></tr>
					<tr class="mat-row" *matNoDataRow>
						<td class="mat-cell" colspan="4">
							@if (inputOfflineFilter.value != '') {
							<span>{{noResultMessage}}:"{{inputOfflineFilter.value}}"</span>
							} @else {
							<span>{{noResultMessage}}</span>
							}
						</td>
					</tr>
				</table>
				<mat-paginator #paginatorOffline [pageSizeOptions]="[5, 10, 25, 100]"
					[pageSize]="filterQueryParams.offlinepageSize ?? 10"
					[pageIndex]="filterQueryParams.offlinepageIndex" (page)="onPageChange(paginatorOffline, $event)"
					aria-label="Select page of rules"></mat-paginator>
			</div>
			}
			@if (offlineEvents && offlineEvents.length == 0) {<div>{{noResultMessage}}</div>}
		</div>
	</div>
</ng-template>

<ng-template #DeviationEventsTab>
	<div class="events-list-div">
		<div class="filter-table-div">
			<mat-form-field>
				<mat-label>Search for an Event</mat-label>
				<input matInput (keyup)="onFilteringDeviationEvents($event)" placeholder="" #inputDeviationFilter
					[(ngModel)]="filterQueryParams.deviationFilter">
			</mat-form-field>
			@if (dataSourceDeviation && dataSourceDeviation.filteredData.length > 0) {
			<div class="table-container">
				<table mat-table matSort #tableDeviation #sortDeviation="matSort" [dataSource]="dataSourceDeviation"
					[matSortActive]="filterQueryParams.deviationSortColumn || ''"
					[matSortDirection]="filterQueryParams.deviationSortDirection || ''"
					(matSortChange)="onDeviationSortChange($event)">
					<ng-container matColumnDef="timestamp">
						<th mat-header-cell *matHeaderCellDef>Timestamp</th>
						<td mat-cell *matCellDef="let row">
							<span class="alignRow">{{row.Timestamp | date:'dd MMMM yyyy HH:mm'}}</span>
						</td>
					</ng-container>
					<ng-container matColumnDef="model">
						<th mat-header-cell *matHeaderCellDef>Model Type</th>
						<td mat-cell *matCellDef="let row">
							<span>{{getModelTypeName(row.ModelType)}}</span>
						</td>
					</ng-container>
					<ng-container matColumnDef="asset">
						<th mat-header-cell *matHeaderCellDef>Asset</th>
						<td mat-cell class="AssetName-no-overflow" *matCellDef="let row">
							@let text = row.AssetName + " - " + row.AssetDescription;
							@if (text.length <= 41) { <span>{{text}}</span>
								} @else {
								<span title="{{text}}">{{text}}</span>
								}
						</td>
					</ng-container>
					<ng-container matColumnDef="zscore">
						<th mat-header-cell *matHeaderCellDef>Z-Score</th>
						<td mat-cell *matCellDef="let row"> {{row.ZScore}}
						</td>
					</ng-container>
					<ng-container matColumnDef="acceptableDeviation">
						<th mat-header-cell *matHeaderCellDef>Tolerance</th>
						<td mat-cell *matCellDef="let row"> {{row.AcceptableDeviation}}
						</td>
					</ng-container>

					<ng-container matColumnDef="CaseID">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>SAP Case</th>
						<td style="justify-content: left;" mat-cell *matCellDef="let row">
							<span class="app-icon">
								<mat-icon [ngStyle]="{'color': row.CaseID ? 'lightgreen':'salmon'}">{{row.CaseID ?
									'check' :
									'close'}}</mat-icon>
							</span>
						</td>
					</ng-container>

					<ng-container matColumnDef="acknowledged">
						<th mat-header-cell *matHeaderCellDef>Acknowledged</th>
						<td [ngStyle]="{'color': !row.Acknowledged ? 'Salmon' : ''}" mat-cell *matCellDef="let row">
							@if (row.Acknowledged && row.AcknowledgedUser != '') {
							<span class="alignRow" matTooltip="By {{row.AcknowledgedUser}}" matTooltipPosition="right">
								{{row.AcknowledgedTimestamp | date:'dd MMMM yyyy'}}
							</span>
							}
							@if (row.Acknowledged && row.AcknowledgedUser == ''){
							<span class="alignRow">Yes</span>
							}
							@if (!row.Acknowledged) {
							<span class="alignRow" style="color: var(--color-red);">No</span>
							}
						</td>
					</ng-container>

					<ng-container matColumnDef="Action">
						<th mat-header-cell *matHeaderCellDef></th>
						<td style="justify-content: left;" mat-cell *matCellDef="let row">
							<span class="app-icon" [matMenuTriggerFor]="RuleActionMenu">
								<mat-icon>more_horiz</mat-icon>
							</span>

							<mat-menu #RuleActionMenu>

								<button mat-menu-item (click)="viewDeviation(row)" class="app-icon">
									<mat-icon>insights</mat-icon><span>Model Details</span>
								</button>

								<button mat-menu-item (click)="goToAsset(row)" class="app-icon app-icon--goto">
									<mat-icon /><span>View Asset</span>
								</button>

							</mat-menu>
						</td>
					</ng-container>

					<ng-container matColumnDef="GoToEvent">
						<th mat-header-cell *matHeaderCellDef></th>
						<td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row">
							<span class="app-icon" (click)="selectDeviationEvent(row)" matTooltip="Go To Event">
								<mat-icon>insights</mat-icon>
							</span>
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumnsDeviation"></tr>
					<tr mat-row class="table-row" *matRowDef="let row; columns: displayedColumnsDeviation;"></tr>
					<tr class="mat-row" *matNoDataRow>
						<td class="mat-cell" colspan="4">
							@if (inputDeviationFilter.value != '') {
							<span>{{noResultMessage}}:"{{inputDeviationFilter.value}}"</span>
							} @else {
							<span>{{noResultMessage}}</span>
							}
						</td>
					</tr>
				</table>
				<mat-paginator #paginatorDeviation [pageSizeOptions]="[5, 10, 25, 100]"
					[pageSize]="filterQueryParams.deviationpageSize ?? 10"
					[pageIndex]="filterQueryParams.deviationpageIndex" (page)="onPageChange(paginatorDeviation,$event)"
					aria-label="Select page of rules"></mat-paginator>
			</div>
			}
			@if (deviationEvents && deviationEvents.length == 0) {<div>{{noResultMessage}}</div>}
		</div>
	</div>
</ng-template>

<ng-template #WebhookEventsTab>
	<div class="events-list-div">
		<div class="filter-table-div">
			<mat-form-field>
				<mat-label>Search for an Event</mat-label>
				<input matInput (keyup)="onFilteringWebhookEvents($event)" placeholder="" #inputWebhookFilter
					[(ngModel)]="filterQueryParams.webhookFilter">
			</mat-form-field>
			@if (dataSourceWebhook && dataSourceWebhook.filteredData.length > 0) {
			<div class="table-container">
				<table mat-table matSort #tableWebhook #sortWebhook="matSort" [dataSource]="dataSourceWebhook"
					[matSortActive]="filterQueryParams.webhookSortColumn || ''"
					[matSortDirection]="filterQueryParams.webhookSortDirection || ''"
					(matSortChange)="onWebhookSortChange($event)">
					<ng-container matColumnDef="timestamp">
						<th mat-header-cell *matHeaderCellDef>Timestamp</th>
						<td mat-cell *matCellDef="let row">
							<span class="alignRow">
								{{row.TimeStamp | date:'dd MMMM yyyy HH:mm'}}
							</span>
						</td>
					</ng-container>
					<ng-container matColumnDef="webhook">
						<th mat-header-cell *matHeaderCellDef>Triggered by Webhook</th>
						<td mat-cell *matCellDef="let row">
							<span>{{row.Description}}</span>
						</td>
					</ng-container>
					<ng-container matColumnDef="type">
						<th mat-header-cell *matHeaderCellDef>Webhook Event Type</th>
						<td mat-cell *matCellDef="let row">
							<span>{{webhookEventTypeToText(row.WebhookEventType)}}</span>
						</td>
					</ng-container>

					<ng-container matColumnDef="Action">
						<th mat-header-cell *matHeaderCellDef></th>
						<td style="justify-content: left;" mat-cell *matCellDef="let row">
							<span class="app-icon" [matMenuTriggerFor]="RuleActionMenu">
								<mat-icon>more_horiz</mat-icon>
							</span>

							<mat-menu #RuleActionMenu>

								<button mat-menu-item (click)="viewWebhook(row)" class="app-icon app-icon--goto">
									<mat-icon /><span>View Webhook</span>
								</button>

							</mat-menu>
						</td>
					</ng-container>

					<ng-container matColumnDef="GoToEvent">
						<th mat-header-cell *matHeaderCellDef></th>
						<td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row">
							<span class="app-icon" (click)="selectWebhookEvent(row)" matTooltip="Go To Event">
								<mat-icon>webhook</mat-icon>
							</span>
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumnsWebhook"></tr>
					<tr mat-row class="table-row" *matRowDef="let row; columns: displayedColumnsWebhook;"></tr>
					<tr class="mat-row" *matNoDataRow>
						<td class="mat-cell" colspan="4">
							@if (inputWebhookFilter.value != '') {
							<span>{{noResultMessage}}:"{{inputWebhookFilter.value}}"</span>
							} @else {
							<span>{{noResultMessage}}</span>
							}
						</td>
					</tr>
				</table>
				<mat-paginator #paginatorWebhook [pageSizeOptions]="[5, 10, 25, 100]"
					[pageSize]="filterQueryParams.webhookpageSize ?? 10"
					[pageIndex]="filterQueryParams.webhookpageIndex" (page)="onPageChange(paginatorWebhook,$event)"
					aria-label="Select page of rules"></mat-paginator>
			</div>
			}
			@if (webhookEvents && webhookEvents.length == 0) {<div>{{noResultMessage}}</div>}
		</div>
	</div>
</ng-template>